import { icon, Icon } from '../lib/fa-icons.js';
/*

*/
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class BumperJan26Widget extends Widget {
	componentWillMount() {
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;
		this.toggleShrink = this.toggleShrink.bind(this);

		if (
			getCookie("tpm_bumper_jan_26_shrunk") === "1" ||
			document.body.getBoundingClientRect().width < 360
		) {
			this.state.shrunk = true;
		}

		document
			.querySelector(".js_site-footer")
			.setAttribute("style", "padding-bottom: 250px");
	}

	toggleShrink(e) {
		e.preventDefault();
		e.stopPropagation();
		const shrunk = !this.state.shrunk;
		if (shrunk) {
			setCookie("tpm_bumper_jan_26_shrunk", "1", 1);
		} else {
			setCookie("tpm_bumper_jan_26_shrunk", "0", 1);
		}

		this.setState({ shrunk: shrunk });
	}

	renderContent() {
		if (this.state.shrunk) {
			return (
				<div className={` BumperJan26 `}>
					<div className={`BumperJan26__Inner`}>
						<div
							className="BumperJan26__Toggle --rotate"
							onClick={this.toggleShrink}
						>
							<Icon name="chevron-down" style="solid" />
						</div>
						<div className="BumperJan26__Body --shrunk">
							<p>Your support makes a difference.</p>

							<div className="BumperJan26__Buttons --margin">
								<a
									href="https://talkingpointsmemo.com/memberships?utm_source=bumper&utm_medium=web&utm_campaign=Jan26"
									className="Button --red"
								>
									25% Off Annual Membership
								</a>
							</div>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className={` BumperJan26 `}>
				<div className={`BumperJan26__Inner`}>
					<div className="BumperJan26__Toggle" onClick={this.toggleShrink}>
						<Icon name="chevron-down" style="solid" />
					</div>
					<div className="BumperJan26__Body">
						<p className="big">
							Our Reporting Is a Record for&nbsp;the&nbsp;Future
						</p>

						<p>
							Your support makes a difference. Join now and get{" "}
							<b>25% off an annual&nbsp;membership.</b>
						</p>

						<div className="BumperJan26__Buttons --margin">
							<a
								href="https://talkingpointsmemo.com/memberships?utm_source=bumper&utm_medium=web&utm_campaign=Jan26"
								className="Button --red"
							>
								25% Off Annual Membership
							</a>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
